import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getClientDocumentList, addClientDocument, deleteClientDocument, updateClientDocument, getClientDocumentType } from "../slice/clientPanelDocumentSlice";

const ClientDocuments = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const { clientsDocument, loading, clientDocumentType } = useSelector((state) => state.clientDocument);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });
  const clientToken = localStorage.getItem("client_access_token");

  const [form, setForm] = useState({
    document_type: "",
    file: null,
  });

  const sortedData = [...(Array.isArray(clientsDocument) ? clientsDocument : [])].sort((a, b) => {
  if (sortConfig.column === null) return 0;

  const key = sortConfig.column;
  const valA = a[key] ?? "";
  const valB = b[key] ?? "";

  if (!isNaN(valA) && !isNaN(valB)) {
    return sortConfig.direction === "asc"
      ? valA - valB
      : valB - valA;
  } else {
    return sortConfig.direction === "asc"
      ? valA.toString().localeCompare(valB.toString())
      : valB.toString().localeCompare(valA.toString());
  }
});

   const handleSort = (columnKey) => {
      let direction = "asc";
      if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
         direction = "desc";
      }
      setSortConfig({ column: columnKey, direction });
   };

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
    } else {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }
  
    return () => {
      // Cleanup on unmount
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    };
  }, [showModal]);

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  useEffect(() => {
    dispatch(getClientDocumentList(clientToken));
    dispatch(getClientDocumentType());
  }, [dispatch]);

    // console.log("clientsDocument", clientsDocument);
    // console.log("clientDocumentType", clientDocumentType);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const handleAddSubmit = async () => {

    if (!form.document_type) {
    toast.error("Please select a document type", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    return;
  }

  if (!form.file) {
    toast.error("Please upload a document file", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    return;
  }

    const formData = new FormData();
    formData.append("file_type", form.document_type);
    formData.append("file_path", form.file);

    const result = await dispatch(addClientDocument({ token: clientToken, formData }));
    if (result.meta.requestStatus === "fulfilled") {
      toast.success("Document added successfully", {
        position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
      });
      handleCloseAddDocumentModal();
      dispatch(getClientDocumentList(clientToken));
    } else {
      toast.error("Failed to add document", {
        position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
      });
    }
  };

  const handleUpdateSubmit = async () => {

    if (!form.document_type) {
    toast.error("Please select a document type", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    return;
  }

    const formData = new FormData();
    formData.append("file_type", form.document_type);
    if (form.file) {
      formData.append("file_path", form.file);
    }

    const result = await dispatch(updateClientDocument({
      token: clientToken,
      documentData: formData,
      documentId: selectedDocument.id,
    }));

    if (result.meta.requestStatus === "fulfilled") {
      toast.success("Document updated successfully", {
        position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
      });
      handleCloseEditDocumentModal();
      dispatch(getClientDocumentList(clientToken));
    } else {
      toast.error("Failed to update document", {
        position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
      });
    }
  };

  const handleAddDocumentModel = () => {
    setForm({ document_type: "", file: null });
    setShowAddModal(true);
  };

  const handleCloseAddDocumentModal = () => {
    setShowAddModal(false);
  };

  const handleEditDocumentModel = (document) => {
    setSelectedDocument(document);
    setForm({
      document_type: document.file_type,
      file: null, // New file to be uploaded
    });
    setShowEditModal(true);
  };

  const handleCloseEditDocumentModal = () => {
    setShowEditModal(false);
  };

  const handleDeleteDocument = async (documentId) => {
    const confirmed = window.confirm("Are you sure you want to delete this document?");
    if (!confirmed) return;

    const result = await dispatch(deleteClientDocument({ token: clientToken, documentId }));

    if (result.meta.requestStatus === "fulfilled") {
      toast.success("Document deleted successfully", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
      dispatch(getClientDocumentList(clientToken)); // Refresh list
    } else {
      toast.error("Failed to delete document", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
  };

  return (
    <>
    <style>{`
      .modal-backdrop-custom {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1040;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
      }
    `}
    </style>

    {showModal && <div className="modal-backdrop-custom"></div>}
      {/* <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="mb-3">List of Documents</h2>
          <button className="btn btn-sm btn-primary" onClick={handleAddDocumentModel}>Add Document</button>
        </div>
        
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>File Type</th>
              <th>File Path</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(clientsDocument) && clientsDocument.length > 0 ? (
              clientsDocument.map((document) => (
                <tr key={document.id}>
                  <td>{document.file_type}</td>
                  <td>{document.file_path}</td>
                  <td>
                    {(() => {
                      const date = new Date(document.created_at);
                      const formattedDate = date.toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                      });

                      const formattedTime = date.toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true,
                      });

                      return `${formattedDate} ${formattedTime}`;
                    })()}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => handleEditDocumentModel(document)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDeleteDocument(document.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2">No images found.</td>
              </tr>
            )}
          </tbody>
        </table>
        {showAddModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Document</h5>
                  <button type="button" className="btn-close" onClick={handleCloseAddDocumentModal} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="document_type" className="form-label">Document Type:</label>
                      <select
                        className="form-control"
                        id="document_type"
                        name="document_type"
                        value={form.document_type}
                        onChange={handleFormChange}
                      >
                        <option value="">Select Document Type</option>
                          {clientDocumentType &&
                            Object.entries(clientDocumentType).map(([key, value]) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                          ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="file" className="form-label">File:</label>
                      <input
                        type="file"
                        className="form-control"
                        id="file"
                        name="file"
                        onChange={handleFormChange}
                      />
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={handleCloseAddDocumentModal}>Close</button>
                  <button className="btn btn-primary" onClick={handleAddSubmit}>Add</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showEditModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Update Document</h5>
                    <button type="button" className="btn-close" onClick={handleCloseEditDocumentModal} aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="mb-3">
                        <label htmlFor="document_type" className="form-label">Document Type:</label>
                        <select
                          className="form-control"
                          id="document_type"
                          name="document_type"
                          value={form.document_type}
                          onChange={handleFormChange}
                        >
                          <option value="">Select Document Type</option>
                          {clientDocumentType &&
                            Object.entries(clientDocumentType).map(([key, value]) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                          ))}
                        </select>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="file" className="form-label">File:</label>
                        <input
                          type="file"
                          className="form-control"
                          id="file"
                          name="file"
                          onChange={handleFormChange}
                        />
                        {selectedDocument?.file_path && (
                          <small className="text-muted">Existing file: {selectedDocument.file_path.split('/').pop()}</small>
                        )}
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={handleCloseEditDocumentModal}>Close</button>
                    <button className="btn btn-primary" onClick={handleUpdateSubmit}>Update</button>
                  </div>
                </div>
              </div>
            </div>
            )}
        </div> */}

        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex">
          My Documents
          <button className="btn btn-danger ms-auto py-2" onClick={handleAddDocumentModel}>
            <i className="fa fa-user-plus me-1"></i> Add Document
          </button>
          </h4>
          <div className="table-responsive">
            {loading ? (
                <p>Loading Documents...</p>
              ) : !clientsDocument || !Array.isArray(clientsDocument) || clientsDocument.length === 0 ? (
                <p>No document found.</p>
              ) : (
            <table className="table table-striped table-bordered align-middle" id="servicesTable">
              <thead>
                <tr>
                  <th className="font-weight-semibold" onClick={() => handleSort("file_type")}>File Type <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("file_path")}>File Path <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold"onClick={() => handleSort("created_at")}>Created At <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold">Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((document, index) => (
                  <tr key={document.id || index}>
                  <td>{document.file_type || "—"}</td>
                  <td>{document.file_path}</td>
                  <td>{(() => {
                      const date = new Date(document.created_at);
                      const formattedDate = date.toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                      });

                      const formattedTime = date.toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true,
                      });

                      return `${formattedDate} ${formattedTime}`;
                    })()}
                  </td>
                  <td>
                    <button
                      className="btn text-primary p-1"
                      onClick={() => handleEditDocumentModel(document)}
                    >
                      <i className="fa fa-pencil font-size-20"></i>
                    </button>
                    <button
                      className="btn btn-md text-danger me-1 p-1"                      
                      onClick={() => handleDeleteDocument(document.id)}
                    >
                      <i className="fa fa-trash font-size-20"></i>
                    </button>
                  </td>
                </tr>
                ))}
              </tbody>
          </table>
           )}
           {showAddModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">Add Document</h5>
                  <button type="button" className="btn-close" onClick={handleCloseAddDocumentModal} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="document_type" className="form-label text-primary mb-1 font-weight-semibold required">Document Type:</label>
                      <select
                        className="form-select"
                        id="document_type"
                        name="document_type"
                        value={form.document_type}
                        onChange={handleFormChange}
                      >
                        <option value="">Select Document Type</option>
                          {clientDocumentType &&
                            Object.entries(clientDocumentType).map(([key, value]) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                          ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="file" className="form-label text-primary mb-1 font-weight-semibold required">File:</label>
                      <div className="d-flex flex-column flex-md-row w-100 gap-3 align-items-start">
                      {/* Upload Field */}
                      <div className="uploadfield flex-fill">
                        <div className="custom-file-upload position-relative">
                          <button
                            type="button"
                            className="upload-btn btn btn-custom-primary position-absolute"
                            onClick={() => document.getElementById('file')?.click()}
                          >
                            Upload Files
                          </button>
                          <input
                            type="file"
                            name="file"
                            id="file"
                            accept=".jpg,.jpeg,.png"
                            multiple
                            onChange={handleFormChange}
                          />
                        </div>
                        <div className="file-name form-control" id="fileName" style={{ height: "auto" }}>
                          {form.file?.name || "No document chosen"}
                        </div>
                      </div>
                    </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleCloseAddDocumentModal}>Close</button>
                  <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleAddSubmit}>Add</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showEditModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">Update Document</h5>
                    <button type="button" className="btn-close" onClick={handleCloseEditDocumentModal} aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="mb-3">
                        <label htmlFor="document_type" className="form-label text-primary mb-1 font-weight-semibold required">Document Type:</label>
                        <select
                          className="form-select"
                          id="document_type"
                          name="document_type"
                          value={form.document_type}
                          onChange={handleFormChange}
                        >
                          <option value="">Select Document Type</option>
                          {clientDocumentType &&
                            Object.entries(clientDocumentType).map(([key, value]) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                          ))}
                        </select>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="file" className="form-label">File:</label>
                        {/* <input
                          type="file"
                          className="form-control"
                          id="file"
                          name="file"
                          onChange={handleFormChange}
                        /> */}
                        <div className="d-flex flex-column flex-md-row w-100 gap-3 align-items-start">
                      {/* Upload Field */}
                      <div className="uploadfield flex-fill">
                        <div className="custom-file-upload position-relative">
                          <button
                            type="button"
                            className="upload-btn btn btn-custom-primary position-absolute"
                            onClick={() => document.getElementById('file')?.click()}
                          >
                            Upload Files
                          </button>
                          <input
                            type="file"
                            name="file"
                            id="file"
                            accept=".jpg,.jpeg,.png"
                            multiple
                            onChange={handleFormChange}
                          />
                        </div>
                        <div className="file-name form-control" id="fileName" style={{ height: "auto" }}>
                          {form.file?.name || "No document chosen"}
                        </div>
                      </div>
                    </div>
                        {selectedDocument?.file_path && (
                          <small className="text-muted">Existing file: {selectedDocument.file_path.split('/').pop()}</small>
                        )}
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-secondary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleCloseEditDocumentModal}>Close</button>
                    <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleUpdateSubmit}>Update</button>
                  </div>
                </div>
              </div>
            </div>
            )}
        </div>
        
        
      </div>
    </div>
    </>
  );
};

export default ClientDocuments;